module.exports = __webpack_public_path__ + "static/media/notification.a9c7b17e.svg";